import Callback from '@/containers/wechat/Callback';

import { ROUTE_WECHAT_CALLBACK } from '@/router/names';

export default [
    {
        path: '/wechat/callback',
        name: ROUTE_WECHAT_CALLBACK,
        component: Callback,
        meta: {
            bridge: true,
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/wechat.js